{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Zastosuj",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "LAST_7_DAYS": "Ostatnie 7 dni",
      "LAST_30_DAYS": "Ostatnie 30 dni",
      "LAST_3_MONTHS": "Ostatnie 3 miesiące",
      "LAST_6_MONTHS": "Ostatnie 6 miesięcy",
      "LAST_YEAR": "Ostatni rok",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Niestandardowy zakres dat"
    }
  }
}
